export default __webpack_public_path__ + "static/media/location-max.a3faa00d.svg";